import { render, staticRenderFns } from "./courseWork.vue?vue&type=template&id=92f6aa6c&scoped=true"
import script from "./courseWork.vue?vue&type=script&lang=ts"
export * from "./courseWork.vue?vue&type=script&lang=ts"
import style0 from "./courseWork.vue?vue&type=style&index=0&id=92f6aa6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f6aa6c",
  null
  
)

export default component.exports